import axios from "axios";
const API_URL = process.env.REACT_APP_API_URL;

export const getPresupuestosByProyectoId = async (proyectoId) => {
  const token = localStorage.getItem("token");
  const response = await axios.get(
    `${API_URL}/proyectos/${proyectoId}/presupuestos`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
  return response.data;
};

export const getPresupuestoById = async (presupuestoId) => {
  const token = localStorage.getItem("token");
  const response = await axios.get(
    `${API_URL}/api/presupuestos/${presupuestoId}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
  return response.data;
};

export const addPresupuesto = async (proyectoId, presupuesto) => {
  const token = localStorage.getItem("token");

  if (!presupuesto.IdCliente || !presupuesto.IdMarca) {
    throw new Error("El cliente y la marca son campos obligatorios.");
  }

  try {
    const response = await axios.post(
      `${API_URL}/api/proyectos/${proyectoId}/presupuestos`,
      {
        ...presupuesto,
        IdProyecto: proyectoId,
        FechaCrear: presupuesto.FechaCrear || null,
        FechaPresentacion: presupuesto.FechaPresentacion || null,
        FechaAceptacion: presupuesto.FechaAceptacion || null,
        FechaCancelacion: presupuesto.FechaCancelacion || null,
        FechaMaximaContestacion: presupuesto.FechaMaximaContestacion || null,
        Estado: presupuesto.Estado || "Created",
        IdProveedor: presupuesto.IdProveedor || null,
        NumeroPresupuesto: `P-${Date.now()}`,
        Temporada: presupuesto.TemporadaId,
        DiseñoMuestra: presupuesto.DiseñoMuestra, // Sin procesar
        IdCliente: presupuesto.IdCliente,
        IdMarca: presupuesto.IdMarca,
        Units: presupuesto.Units || 0, // Incluir Units
        Notas: presupuesto.Notas,
        designCliente: presupuesto.designCliente || null,
        Id_Incoterm: presupuesto.Id_Incoterm || null,
        IdProducto: presupuesto.IdProducto || null,
        IdMuestra: presupuesto.IdMuestra || null,

        TipoPrenda: presupuesto.TipoPrenda || null,
        ABREVIATURA: presupuesto.ABREVIATURA || null,
        VOL: presupuesto.VOL || null,
        IdSubgrupo: presupuesto.IdSubgrupo || null,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response.data;
  } catch (error) {
    console.error("Error creando presupuesto:", error);
    throw new Error(
      error.response?.data?.error ||
        "Ocurrió un error al crear el presupuesto.",
    );
  }
};

export const getAllProyectos = async () => {
  const token = localStorage.getItem("token");
  const response = await axios.get(`${API_URL}/api/proyectos`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

export const saveBudgetLinesToAPI = async (lines) => {
  try {
    const response = await axios.post(
      `${API_URL}/budget-lines`,
      { lines },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      },
    );
    return response.data;
  } catch (error) {
    throw new Error("Error saving budget lines:", error);
  }
};

export const updatePresupuestoEstado = async (presupuestoId, estado, fecha) => {
  const token = localStorage.getItem("token");
  try {
    const response = await axios.put(
      `${API_URL}/presupuestos/${presupuestoId}/estado`,
      { estado, fecha },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response.data;
  } catch (error) {
    throw new Error("Error saving Estados:", error);
  }
};

/* para los aceptados del Critical Path */
export const getProductosEnProduccion = async () => {
  const token = localStorage.getItem("token");
  const response = await axios.get(`${API_URL}/api/presupuestos/produccion`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

export const initializeTimelineForProduct = async (productId) => {
  const token = localStorage.getItem("token");
  const response = await axios.post(
    `${API_URL}/api/productionTimeline/timeline/init/${productId}`,
    {},
    {
      headers: { Authorization: `Bearer ${token}` },
    },
  );
  return response.data;
};

/* 📥 Obtener timeline de un producto específico */
export const getTimelineByProductId = async (productId, options = {}) => {
  const token = localStorage.getItem("token");
  const idPresupuesto = options.idPresupuesto;
  const idPresupuestoA3Pedido = options.idPresupuestoA3Pedido;
  const params = {};
  if (
    idPresupuesto != null &&
    idPresupuesto !== "" &&
    Number.isFinite(Number(idPresupuesto))
  ) {
    params.idPresupuesto = Number(idPresupuesto);
  }
  if (
    idPresupuestoA3Pedido != null &&
    idPresupuestoA3Pedido !== "" &&
    Number.isFinite(Number(idPresupuestoA3Pedido))
  ) {
    params.idPresupuestoA3Pedido = Number(idPresupuestoA3Pedido);
  }
  const response = await axios.get(
    `${API_URL}/api/productionTimeline/timeline/${productId}`,
    {
      // No añadir Cache-Control/Pragma aquí: son cabeceras “no simples” y disparan preflight CORS;
      // muchos backends no las incluyen en Access-Control-Allow-Headers y el XHR falla.
      headers: { Authorization: `Bearer ${token}` },
      params,
    },
  );
  return response.data;
};

/** Bulk timeline + presupuesto para NotasResumen (evita N peticiones individuales). */
export const getTimelinesBulkForHub = async (items) => {
  if (!Array.isArray(items) || items.length === 0) return { items: [] };

  const token = localStorage.getItem("token");
  try {
    const { data } = await axios.post(
      `${API_URL}/api/productionTimeline/timeline/bulk-for-hub`,
      { items },
      {
        headers: { Authorization: `Bearer ${token}` },
        validateStatus: (status) => status === 200,
      },
    );
    return data;
  } catch (error) {
    const status = error?.response?.status;
    if (status === 404 || status === 405) {
      return null;
    }
    throw error;
  }
};

/** Elimina tareas timeline legacy (sin pedido A3) para migrar al circuito por pedidos. */
export const purgeLegacyTimeline = async ({
  idPresupuesto = null,
  productId = null,
} = {}) => {
  const token = localStorage.getItem("token");
  const { data } = await axios.post(
    `${API_URL}/api/productionTimeline/purge-legacy-timeline`,
    { idPresupuesto, productId },
    {
      headers: { Authorization: `Bearer ${token}` },
    },
  );
  return data;
};

/** Inicializa timeline (si no existe) y vincula CP al pedido con unidades de prendas. */
export const linkCriticalPathFromPedido = async ({
  productId,
  idPresupuestoA3Pedido,
  unidadesPrendasPedido,
}) => {
  const token = localStorage.getItem("token");
  const { data } = await axios.post(
    `${API_URL}/api/productionTimeline/cp-from-pedido`,
    {
      productId,
      idPresupuestoA3Pedido,
      unidadesPrendasPedido,
    },
    {
      headers: { Authorization: `Bearer ${token}` },
    },
  );
  return data;
};

/** Reconciliación manual de CP: rellena vínculos/timelines faltantes desde pedidos A3. */
export const backfillCriticalPathFromPedidos = async () => {
  const token = localStorage.getItem("token");
  const { data } = await axios.post(
    `${API_URL}/api/productionTimeline/cp-backfill-from-pedidos`,
    {},
    {
      headers: { Authorization: `Bearer ${token}` },
    },
  );
  return data;
};

// pinta las muestras en el Critical Path
export const getCriticalPathMuestras = async () => {
  const token = localStorage.getItem("token");
  const res = await axios.get(`${API_URL}/api/critical-path-muestras`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.data;
};

/* ➕ Agregar una nueva tarea al timeline */
export const addTimelineTask = async (task) => {
  const token = localStorage.getItem("token");
  const response = await axios.post(
    `${API_URL}/api/productionTimeline/timeline`,
    task,
    {
      headers: { Authorization: `Bearer ${token}` },
    },
  );
  return response.data;
};

/* ✏️ Actualizar una tarea existente (Producción o Muestra) */
export const updateTimelineTask = async (taskId, updatedTask) => {
  const token = localStorage.getItem("token");

  // 🟣 MUESTRAS → sin :id, se identifican por ID_MUESTRA + TaskName
  if (updatedTask?.ID_MUESTRA) {
    const response = await axios.put(
      `${API_URL}/api/productionTimeline/timeline`,
      updatedTask,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );
    return response.data;
  }

  // 🟢 PRODUCCIÓN → con :id
  const response = await axios.put(
    `${API_URL}/api/productionTimeline/timeline/${taskId}`,
    updatedTask,
    {
      headers: { Authorization: `Bearer ${token}` },
    },
  );

  return response.data;
};

/* 🗑️ Eliminar una tarea del timeline */
export const deleteTimelineTask = async (taskId) => {
  const token = localStorage.getItem("token");
  const response = await axios.delete(
    `${API_URL}/api/productionTimeline/timeline/${taskId}`,
    {
      headers: { Authorization: `Bearer ${token}` },
    },
  );
  return response.data;
};

// estimatesApi.js
export const getCriticalPathHorizontal = async (includeClosed = false) => {
  const response = await axios.get(`${API_URL}/api/critical-path-horizontal`, {
    params: { includeClosed: includeClosed ? 1 : 0 },
  });
  return response.data;
};

// estimatesApi.js
export const getCriticalPathHorizontal1 = async (includeClosed = false) => {
  const response = await axios.get(`${API_URL}/api/critical-path-horizontal1`, {
    params: { includeClosed: includeClosed ? 1 : 0 },
  });
  return response.data;
};

export const setCriticalPathEntityClosed = async ({
  productId = null,
  idPresupuestoA3Pedido = null,
  idMuestra = null,
  isClosed = false,
}) => {
  const token = localStorage.getItem("token");
  const payload =
    idPresupuestoA3Pedido != null &&
    idPresupuestoA3Pedido !== "" &&
    Number.isFinite(Number(idPresupuestoA3Pedido))
      ? {
          productId: null,
          idPresupuestoA3Pedido: Number(idPresupuestoA3Pedido),
          idMuestra: null,
          isClosed,
        }
      : idMuestra != null &&
          idMuestra !== "" &&
          Number.isFinite(Number(idMuestra))
        ? {
            productId: null,
            idPresupuestoA3Pedido: null,
            idMuestra: Number(idMuestra),
            isClosed,
          }
        : {
            productId:
              productId != null &&
              productId !== "" &&
              Number.isFinite(Number(productId))
                ? Number(productId)
                : null,
            idPresupuestoA3Pedido: null,
            idMuestra: null,
            isClosed,
          };
  const response = await axios.put(
    `${API_URL}/api/critical-path-entity-close`,
    payload,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
  return response.data;
};

export const getCriticalPathClosedEntities = async () => {
  const token = localStorage.getItem("token");
  const response = await axios.get(`${API_URL}/api/critical-path-entity-close`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

export const getPresupuestoInfoByProductId = async (productId, options = {}) => {
  const token = localStorage.getItem("token");
  const idPresupuesto = options.idPresupuesto;
  const idPresupuestoA3Pedido = options.idPresupuestoA3Pedido;
  const params = {};
  if (
    idPresupuesto != null &&
    idPresupuesto !== "" &&
    Number.isFinite(Number(idPresupuesto))
  ) {
    params.idPresupuesto = Number(idPresupuesto);
  }
  if (
    idPresupuestoA3Pedido != null &&
    idPresupuestoA3Pedido !== "" &&
    Number.isFinite(Number(idPresupuestoA3Pedido))
  ) {
    params.idPresupuestoA3Pedido = Number(idPresupuestoA3Pedido);
  }

  const cacheKey = JSON.stringify({
    productId: Number(productId) || 0,
    ...params,
  });
  if (getPresupuestoInfoByProductId._cache?.has(cacheKey)) {
    return getPresupuestoInfoByProductId._cache.get(cacheKey);
  }

  try {
    const response = await axios.get(
      `${API_URL}/api/productionTimeline/presupuestos/info/${productId}`,
      {
        headers: { Authorization: `Bearer ${token}` },
        params,
        validateStatus: (status) => status === 200 || status === 404,
      },
    );
    const data =
      response.status === 200 && response.data ? response.data : null;
    getPresupuestoInfoByProductId._cache?.set(cacheKey, data);
    return data;
  } catch (error) {
    if (error?.response?.status !== 404) {
      console.error("Error obteniendo presupuestoInfo:", error);
    }
    getPresupuestoInfoByProductId._cache?.set(cacheKey, null);
    return null;
  }
};
getPresupuestoInfoByProductId._cache = new Map();

export const getPresupuestosHistoricos = async (
  tipoPrenda,
  idSubgrupo,
  idCliente,
) => {
  const token = localStorage.getItem("token");

  const response = await axios.get(`${API_URL}/api/presupuestos/historicos`, {
    params: { tipoPrenda, idSubgrupo, idCliente },
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

// Añadir notas a Critical Path
export const getNotasByProduct = async (productId) => {
  const token = localStorage.getItem("token");
  const response = await axios.get(
    `${API_URL}/api/criticalpath/notas/${productId}`,
    {
      headers: { Authorization: `Bearer ${token}` },
    },
  );
  return response.data;
};

// Añadir notas a Critical Path
export const addNotaToProduct = async ({
  productId,
  nota,
  usuario,
  tipoNota,
  writer,
  responsible,
  targetDate,
  closingDate,
  status,
}) => {
  const token = localStorage.getItem("token");

  const response = await axios.post(
    `${API_URL}/api/criticalpath/notas`,
    {
      productId,
      nota,
      usuario,
      tipoNota,
      writer,
      responsible,
      targetDate,
      closingDate,
      status,
    },
    {
      headers: { Authorization: `Bearer ${token}` },
    },
  );

  return response.data;
};

// updateNota
export const updateNota = async (
  id,
  { nota, tipoNota, writer, responsible, targetDate, closingDate, status },
) => {
  const token = localStorage.getItem("token");

  const response = await axios.put(
    `${API_URL}/api/criticalpath/notas/${id}`,
    {
      nota,
      tipoNota,
      writer,
      responsible,
      targetDate,
      closingDate,
      status,
    },
    {
      headers: { Authorization: `Bearer ${token}` },
    },
  );

  return response.data;
};

// Elimianr Nota
export const deleteNota = async (id) => {
  const token = localStorage.getItem("token");
  const response = await axios.delete(
    `${API_URL}/api/criticalpath/notas/${id}`,
    {
      headers: { Authorization: `Bearer ${token}` },
    },
  );
  return response.data;
};
